export const getModuleMessages = async (locale: string) => import(`@/modules/sell/locales/${locale}.json`);

export default getModuleMessages;
